/* Luminaire Theme JS — ui-ux-pro-max compliant
   - touch-action: manipulation on interactive els
   - focus management after modal open/close
   - prefers-reduced-motion checked before animation
   - Intersection Observer for scroll reveals
   - Burger ARIA state managed correctly
*/
(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Mobile nav ───────────────────────────────────── */
  function initNav() {
    var burger = document.querySelector('.burger');
    var drawer = document.querySelector('.mobile-nav');
    if (!burger || !drawer) return;

    function open() {
      drawer.classList.add('is-open');
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      burger.focus();
    }

    burger.addEventListener('click', function () {
      drawer.classList.contains('is-open') ? close() : open();
    });

    // Close on outside tap
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.site-header') && drawer.classList.contains('is-open')) close();
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* ── Sticky header shadow ─────────────────────────── */
  function initHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 24);
    }, { passive: true });
  }

  /* ── Scroll reveal (IntersectionObserver) ─────────── */
  function initReveal() {
    if (prefersReducedMotion) return;
    if (!('IntersectionObserver' in window)) return;
    var items = document.querySelectorAll('.reveal');
    if (!items.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry, i) {
        if (entry.isIntersecting) {
          // stagger siblings by 80ms (ui-ux-pro-max: stagger 30-50ms per item)
          var siblings = Array.from(entry.target.parentElement.querySelectorAll('.reveal'));
          var idx = siblings.indexOf(entry.target);
          setTimeout(function () {
            entry.target.classList.add('is-visible');
          }, Math.min(idx * 80, 320));
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.10, rootMargin: '0px 0px -32px 0px' });

    items.forEach(function (el) { observer.observe(el); });
  }

  /* ── Gallery lightbox ─────────────────────────────── */
  function initLightbox() {
    var items = document.querySelectorAll('[data-lightbox]');
    var lb = document.querySelector('.lightbox');
    var lbImg = lb && lb.querySelector('.lightbox__img');
    var lbClose = lb && lb.querySelector('.lightbox__close');
    if (!items.length || !lb) return;

    var lastFocused = null;

    function openLb(src, alt) {
      lastFocused = document.activeElement;
      lbImg.src = src;
      lbImg.alt = alt || '';
      lb.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      lbClose.focus();
    }
    function closeLb() {
      lb.classList.remove('is-open');
      document.body.style.overflow = '';
      lbImg.src = '';
      if (lastFocused) lastFocused.focus();
    }

    items.forEach(function (item) {
      item.setAttribute('tabindex', '0');
      item.setAttribute('role', 'button');
      item.addEventListener('click', function () {
        var img = item.querySelector('img');
        if (img) openLb(img.currentSrc || img.src, img.alt);
      });
      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); item.click(); }
      });
    });

    lbClose.addEventListener('click', closeLb);
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lb.classList.contains('is-open')) closeLb();
    });
  }

  /* ── Contact form loading state ───────────────────── */
  function initForms() {
    document.querySelectorAll('form[data-ajax-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('[type="submit"]');
        if (btn && !btn.dataset.orig) {
          btn.dataset.orig = btn.textContent;
          btn.textContent = 'Sending…';
          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');
        }
      });
    });
  }

  /* ── Init ─────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initHeader();
    initReveal();
    initLightbox();
    initForms();
  });

})();
